import React from "react";

import { window } from "browser-monads";

import theme from "../../utils/theme";
import { Container } from "./styles";

import Icon from "../Icon";
const BackButton = ({ sideMargin }) => {
  const backButtonClickedHandler = () => window.history.back();

  return (
    <Container sideMargin={sideMargin} onClick={backButtonClickedHandler}>
      <Icon iconName='chevron-left' color={theme.colors.mainText} size='lg' />
    </Container>
  );
};

export default BackButton;
